
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

define('component!SecondFactorFormComponent',['require','translate','prop-types','react','react-dom','component!ButtonComponent','lib/Podio.Colors'],function (require) {
    'use strict';

    var t = require('translate');
    var PropTypes = require('prop-types');
    var React = require('react');
    var ReactDOM = require('react-dom');
    var Button = require('component!ButtonComponent');
    var PodioColors = require('lib/Podio.Colors');

    var SecondFactorFormComponent = (function (_React$Component) {
        _inherits(SecondFactorFormComponent, _React$Component);

        function SecondFactorFormComponent(props) {
            _classCallCheck(this, SecondFactorFormComponent);

            _get(Object.getPrototypeOf(SecondFactorFormComponent.prototype), 'constructor', this).call(this, props);
            this.secondFactorInput = React.createRef();
        }

        _createClass(SecondFactorFormComponent, [{
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                ReactDOM.findDOMNode(this.secondFactorInput.current).focus();
            }
        }, {
            key: 'render',
            value: function render() {
                return React.createElement(
                    'form',
                    { className: 'login-form-component', id: 'loginForm', onSubmit: this.props.onSubmit, onKeyPress: this.props.onKeyPress, autoComplete: 'off' },
                    React.createElement(
                        'h2',
                        { className: 'second_factor-form__header' },
                        this.props.useRecoveryCode ? this.props.translations.podio_recovery_code : this.props.translations.podio_otp
                    ),
                    React.createElement(
                        'span',
                        { className: 'second_factor-form__subheader' },
                        this.props.useRecoveryCode ? this.props.translations.use_code_from_recovery_list : this.props.translations.use_code_from_app
                    ),
                    React.createElement(
                        'div',
                        { className: 'login-form-component__input-fields' },
                        React.createElement(
                            'div',
                            { className: 'login-form-component__input-fields__row__name' },
                            this.props.translations.otp
                        ),
                        React.createElement(
                            'div',
                            { className: 'login-form-component__input-fields__row' },
                            this.props.useRecoveryCode ? React.createElement('input', {
                                className: 'login-form-component__input-fields__row__input' + (this.props.validation.recoveryCode.invalid ? ' invalid-field' : ''),
                                required: true,
                                id: 'recoveryCode',
                                name: 'recoveryCode',
                                tabIndex: '1',
                                type: 'text',
                                ref: this.secondFactorInput,
                                value: this.props.recoveryCode,
                                onChange: this.props.onChange,
                                onBlur: this.props.onBlur
                            }) : React.createElement('input', {
                                className: 'login-form-component__input-fields__row__input' + (this.props.validation.otp.invalid ? ' invalid-field' : ''),
                                autoFocus: true,
                                required: true,
                                id: 'otp',
                                name: 'otp',
                                tabIndex: '1',
                                type: 'number',
                                ref: this.secondFactorInput,
                                value: this.props.otp,
                                onChange: this.props.onChange,
                                onBlur: this.props.onBlur
                            })
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'second-factor-form-component__buttons' },
                        React.createElement(Button, {
                            type: 'button',
                            id: 'BackToSignInButton',
                            name: 'backtosignin',
                            className: 'second-factor-form__button second-factor-form__backButton',
                            tabIndex: '2',
                            disabled: this.props.isSubmitting,
                            label: this.props.translations.cancel_code_verify,
                            onClick: this.props.onBackToSignIn
                        }),
                        React.createElement(Button, {
                            type: 'submit',
                            id: 'SecondFactorSubmitButton',
                            name: 'commit',
                            className: 'second-factor-form__button',
                            tabIndex: '3',
                            disabled: this.props.isSubmitting,
                            label: this.props.translations.code_verify
                        })
                    )
                );
            }
        }]);

        return SecondFactorFormComponent;
    })(React.Component);

    SecondFactorFormComponent.propTypes = {
        useRecoveryCode: PropTypes.bool,
        onBackToSignIn: PropTypes.func,
        onSubmit: PropTypes.func,
        onKeyPress: PropTypes.func,
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        isSubmitting: PropTypes.bool,
        translations: PropTypes.shape({
            podio_otp: PropTypes.string.isRequired,
            use_code_from_app: PropTypes.string.isRequired,
            podio_recovery_code: PropTypes.string.isRequired,
            use_code_from_recovery_list: PropTypes.string.isRequired,
            code_verify: PropTypes.string.isRequired,
            cancel_code_verify: PropTypes.string.isRequired,
            otp: PropTypes.string.isRequired,
            recoveryCode: PropTypes.string.isRequired
        }),
        validation: PropTypes.shape({
            otp: PropTypes.shape({
                invalid: PropTypes.bool,
                errorMessage: PropTypes.string
            }),
            recoveryCode: PropTypes.shape({
                invalid: PropTypes.bool,
                errorMessage: PropTypes.string
            })
        })
    };

    SecondFactorFormComponent.defaultProps = {};

    return SecondFactorFormComponent;
});
